// extracted by mini-css-extract-plugin
export default {"handover_note_tag":"styles_handover_note_tag__CUz2p","handover_note_label":"styles_handover_note_label__WrAvs"};